<template>
<div class="shadow-box">
  <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-right: 0;">
    <div class="flex-row">
      <span>子账号管理</span> 
      <div class="link" v-if="roleType !== 1">
	        <b>移动端报单链接：</b>{{ cOrderLink }}
        <el-button
          v-clipboard:copy="cOrderLink"
          v-clipboard:success="() => $message.success('复制成功')"
          type="text">复制</el-button>
      </div>
    </div>
    <span class="header-actions flex-row flex-secondary-axis-center">
      <span v-if="roleType !== 1" class="commission-rate-info" style="margin-right: 16px;">
        <b>折扣点：</b>{{ commissionRateLabel }}
        <i class="el-icon-edit edit-icon" @click="handleEditCommissionRate"></i>
      </span>
      <el-button
        v-if="roleType !== 1"
        icon="el-icon-copy-document"
        v-clipboard:copy="exclusiveRegisterLink"
        v-clipboard:success="() => $message.success('复制成功')"
      >专属注册链接</el-button>
      <el-button v-if="roleType !== 1" type="primary" @click="showBatchEditDialog = true">批量修改</el-button>
      <el-button icon="el-icon-plus" v-if="roleType !== 1" @click="editRow = null; parentDepart = null; showCreateDrawer = true;" type="primary">新增成员</el-button>
    </span>
  </div>
  <el-dialog
    :visible.sync="showCommissionRateDialog"
    title="修改折扣点"
    width="520px"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form label-width="80px">
      <el-form-item label="折扣点">
        <el-input
          v-model="commissionRateForm.subCommissionRate"
          placeholder="请输入折扣点，如3表示3%"
          @input="validateCommissionRateInput"
        >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="showCommissionRateDialog = false">取消</el-button>
      <el-button type="primary" :loading="commissionRateSaving" @click="saveCommissionRate">保存</el-button>
    </div>
  </el-dialog>
  <el-dialog :close-on-click-modal="false" :visible.sync="showBatchEditDialog" title="批量修改" width="520px">
    <div class="batch-edit">
      <div>批量将高佣商品佣金比例 =</div>
      <el-input class="input" v-model="batchEditForm.oldBd" clearable
        placeholder="78%填写78"
        @input="validateNumberInput('oldBd', $event)"></el-input>
      <div> 改为 </div>
      <el-input  class="input" v-model="batchEditForm.newBd" clearable
        placeholder="78%填写78"
        @input="validateNumberInput('newBd', $event)"></el-input>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="text" @click="batchEditFormClear(); showBatchEditDialog = false;">取消</el-button>
      <el-button type="primary" @click="batchEditSubmit">保存</el-button>
    </div>
  </el-dialog>
  <div class="page-main_box">
    <div class="flex-row search-box">
      <div class="search-item">
        <div class="label">昵称：</div>
        <el-input v-model="form.nickName" @blur="goSearch" @clear="goSearch" clearable placeholder="请输入昵称"></el-input>
      </div>
      <div class="search-item">
        <div class="label">手机号：</div>
        <el-input v-model="form.mobilePhone" @blur="goSearch" @clear="goSearch" clearable placeholder="请输入手机号"></el-input>
      </div>
      <div class="search-item">
        <div class="label">创建时间：</div>
        <el-date-picker
          v-model="form.createDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
          :picker-options="createDatePickerOptions"
          @change="goSearch">
        </el-date-picker>
      </div>
      <el-button type="primary" @click="goSearch">查 询</el-button>
    </div>
    <div class="code-list-content">
      <!-- 账号 昵称 拼多多佣金 抖音M2S佣金。渠道号 状态 创建日期 操作 -->
      <el-table
        row-key="id"
        border
        stripe
        default-expand-all
        style="width: calc(100vw - 280px);"
        height="calc(100vh - 260px)"
        :data="tableData"
        v-loading="isLoading" >
        <el-table-column
          prop="mobilePhone"
          fixed
          label="账号"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="nickName"
          label="昵称"
          min-width="120"> 
        </el-table-column>
        <el-table-column
          prop="bd"
          min-width="140"
          label="高佣商品佣金比例">
          <template slot-scope="{ row }">
            <div v-if="row.userPromotion && row.userPromotion.bd">
              {{ (row.userPromotion.bd / 1000).toFixed(2) + '%' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="bd"
          min-width="220">
          <template slot="header" slot-scope="scope">
            <div>高佣商品一级渠道固定扣点(%)
              <el-tooltip effect="dark"  placement="top">
                <template slot="content">
                  设置后，该二级渠道在选品库看到的佣金比例会<br />自动比一级渠道少几个点，并且报单后会按此结算
                </template>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="{ row }">
            <div v-if="row.userPromotion && row.userPromotion.bdChannelDeduction >= 0">
              {{ (row.userPromotion.bdChannelDeduction / 1000).toFixed(2) + '%' }}
            </div>
          </template>
        </el-table-column>


        <!-- <el-table-column
          prop="status"
          min-width="140"
          label="专属商品佣金比例">
          <template slot-scope="{ row }">
            <div v-if="row.userPromotion && row.userPromotion.bdZs">
              {{ (row.userPromotion.bdZs / 1000).toFixed(2) + '%' }}
            </div>
          </template>
        </el-table-column> -->

        <!-- <el-table-column
          prop="bd"
          min-width="200">
          <template slot="header" slot-scope="scope">
            <div>专属商品一级渠道固定扣点(%)</div>
          </template>
          <template slot-scope="{ row }">
            <div v-if="row.userPromotion && row.userPromotion.bdZsChannelDeduction">
              {{ (row.userPromotion.bdZsChannelDeduction / 1000).toFixed(2) + '%' }}
            </div>
          </template>
        </el-table-column> -->
        
        <!-- <el-table-column
          prop="douyinM2s"
          label="抖音M2S佣金"
          show-overflow-tooltip
          min-width="120">
          <template slot-scope="{ row }">
            <div v-if="row.userPromotion && row.userPromotion.douyinM2s">
              {{ (row.userPromotion.douyinM2s / 1000).toFixed(2) + '%' }}
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="cpaChannel"
          label="渠道号"
          min-width="120">
        </el-table-column> -->
        <el-table-column
          prop="accountStatus"
          label="状态"
          show-overflow-tooltip
          min-width="140">
          <template slot-scope="{ row }">
            <el-switch :value="row.account.accountStatus"
              active-color="#0076F6"
              inactive-color="#f4f5f7"
              @change="e => flagChange(e, row)"
              :active-value="'show'"
              :inactive-value="'del'">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          show-overflow-tooltip
          min-width="160">
          <template slot-scope="{ row }">
            <div>
              {{ row.createTime | filterDate }}
            </div>
          </template>
        </el-table-column> 
        <el-table-column
          fixed="right"
          label="操作"
          width="180">
          <template slot-scope="{ row }">
            <div>
              <el-button type="text" @click="editHander(row)">编辑</el-button>
              <!-- <el-button type="text" >修改密码</el-button>
              <el-button type="text">查看收益</el-button>
              <el-button type="text">获取推荐码</el-button> -->
              <el-button type="text"
                v-clipboard:copy="row.cOrderLink"
                v-clipboard:success="() => $message.success('复制成功')">复制移动端报单链接</el-button> 
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="bd--pag">
        <el-pagination
          class="d-ib"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          :page-sizes="pageInfo.sizes"
          :page-size="pageInfo.size"
          :current-page="pageInfo.current"
          @current-change="pageInfo.current = arguments[ 0 ], getList()"
          @size-change="pageInfo.size = arguments[ 0 ], getList()">
        </el-pagination>
      </div> 
    </div>
  </div>

  <!-- 新增/修改 -->
  <createDrawer
    v-if="showCreateDrawer"
    v-model="showCreateDrawer"
    :editRow="editRow"
    :parentDepart="parentDepart"
    @close="showCreateDrawer = false"
    @on-success="successHandler"
  ></createDrawer>

</div>
</template>
<script>
import NP from 'number-precision'
import createDrawer from '@/page/component/sections/team/account-drawer'
import { getGroupInfoList, setTeamAccountStatus, batchUpdateBd } from '@/service/apis/group'
import { getBdDownStreamCommissionRate, saveBdDownStreamCommissionRate } from '@/service/apis/mall'
import { getUserId, getRoletype } from '@/utils/getUser';
const dayjs = require('dayjs')
const domain = location.host.replace('bd-pc', 'bd')
// const baseLink = location.protocol + '//' + domain + '/#/?qdAccountId='
const baseLink = 'https://bd.jwhdz.com/#/?qdAccountId='
const exclusiveRegisterBaseLink = 'https://xp.bpsheab.com/#/pages/login/register?qdAccountId='

export default {
  components: { 
    createDrawer
   },
   computed: {
    cOrderLink () {
      return `${baseLink}${getUserId()}`
    },
    exclusiveRegisterLink () {
      return `${exclusiveRegisterBaseLink}${getUserId()}`
    },
    roleType () {
      return getRoletype()
    },
    createDatePickerOptions () {
      return {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    },
    commissionRateLabel () {
      const rate = this.commissionRateInfo && this.commissionRateInfo.subCommissionRate
      if (this.hasCustomCommissionRate) {
        return `${(Number(rate) / 100).toFixed(2)}%`
      }
      return '默认3%'
    },
    hasCustomCommissionRate () {
      const rate = this.commissionRateInfo && this.commissionRateInfo.subCommissionRate
      return rate != null && rate !== '' && !isNaN(Number(rate))
    }
   },
  data () {
    return {
      showBatchEditDialog: false,
      showCommissionRateDialog: false,
      commissionRateSaving: false,
      commissionRateInfo: null,
      commissionRateForm: {
        subCommissionRate: ''
      },
      batchEditForm: {
        oldBd: '',
        newBd: ''
      },
      form: {
        nickName: '',
        mobilePhone: '',
        createDate: []
      },
      pageInfo: {
        current: 1,
        size: 10,
        sizes: [ 10, 20, 30, 50, 100 ],
        pages: 0,
        total: 0
      },
      isLoading: false,
      tableData: [],
      editRow: null,
      parentDepart: null,
      showCreateDrawer: false
    }
  },
  filters: {
    filterDate (date) {
      if (date) {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  created () {
    this.$nextTick(() => {
      this.getList()
      if (this.roleType !== 1) {
        this.fetchCommissionRate()
      }
    })
  },
  methods: {
    fetchCommissionRate () {
      getBdDownStreamCommissionRate.call(this).then(res => {
        const rate = res && res.subCommissionRate
        if (rate != null && rate !== '' && !isNaN(Number(rate))) {
          this.commissionRateInfo = res
        } else {
          this.commissionRateInfo = null
        }
      }).catch(() => {
        this.commissionRateInfo = null
      })
    },
    handleEditCommissionRate () {
      if (this.hasCustomCommissionRate) {
        this.commissionRateForm.subCommissionRate = String(Number(this.commissionRateInfo.subCommissionRate) / 100)
      } else {
        this.commissionRateForm.subCommissionRate = ''
      }
      this.showCommissionRateDialog = true
    },
    validateCommissionRateInput (value) {
      this.commissionRateForm.subCommissionRate = value
        .replace(/[^\d.]/g, '')
        .replace(/\.{2,}/g, '.')
        .replace(/^(\d+\.?\d{0,2}).*$/, '$1')
        .replace(/^(\d+\.?\d*)(.*)$/, '$1')
    },
    saveCommissionRate () {
      const val = this.commissionRateForm.subCommissionRate
      if (val === '' || val == null) {
        this.$message.error('请输入折扣点')
        return
      }
      if (isNaN(Number(val))) {
        this.$message.error('请输入有效的折扣点')
        return
      }
      this.commissionRateSaving = true
      saveBdDownStreamCommissionRate.call(this, {
        subCommissionRate: NP.times(val, 100)
      }).then(() => {
        this.$message.success('保存成功')
        this.showCommissionRateDialog = false
        this.fetchCommissionRate()
      }).finally(() => {
        this.commissionRateSaving = false
      })
    },
    batchEditFormClear () {
      this.batchEditForm.oldBd = ''
      this.batchEditForm.newBd = ''
    },
    batchEditSubmit () {
      if (!this.batchEditForm.oldBd) {
        this.$message.error('请输入修改前的佣金比例')
        return
      }
      if (!this.batchEditForm.newBd) {
        this.$message.error('请输入修改后的佣金比例')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '更新中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      batchUpdateBd.call(this, {
        oldBd: NP.times(this.batchEditForm.oldBd, 1000),
        newBd: NP.times(this.batchEditForm.newBd, 1000)
      }).then(res => {
        this.$message.success(res || '批量修改成功')
        this.batchEditFormClear()
        this.showBatchEditDialog = false
        this.getList()
      }).finally(() => {
        loading.close()
      })
    },
    validateNumberInput(field, value) {
      // 使用正则表达式只允许输入数字和小数点
      let numericValue = value.replace(/[^\d.]/g, '') // 只保留数字和小数点
        .replace(/^(\d+\.?\d*)(.*)$/, '$1') // 只保留第一个小数点
        // .replace(/^(\d+\.?\d{0,2}).*$/, '$1') // 限制小数点后最多两位

      // 整数
      // numericValue = numericValue.replace(/[.]/g, '') // 去掉小数点
      
      this.batchEditForm[field] = numericValue
    },
    editHander (row) {
      this.editRow = row
      this.showCreateDrawer = true
    },
    flagChange (e, row) {
      const loading = this.$loading({
        lock: true,
        text: '更新中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      setTeamAccountStatus.call(this, row.accountId).then(res => {
        this.getList()
        this.$message.success('更新状态成功')
      }).finally(() => {
        loading.close()
      })
    },
    getList () { 
      this.isLoading = true
      this.tableData = []
      const opt = {
        current: this.pageInfo.current,
        size: this.pageInfo.size
      }
      if (this.form.mobilePhone) {
        opt.mobilePhone = this.form.mobilePhone
      }
      if (this.form.nickName) {
        opt.nickName = this.form.nickName
      }
      if (this.form.createDate && this.form.createDate.length) {
        opt.createTimeStart = dayjs(this.form.createDate[0]).format('YYYY-MM-DD') + ' 00:00:00'
        opt.createTimeEnd = dayjs(this.form.createDate[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      getGroupInfoList.call(this, opt).then((res) => {
        const {records, pages, total} = res
        this.pageInfo.total = total || 0
        this.pageInfo.pages = pages || 0
        this.tableData = [...(records || [])].map(item => {
          return {
            ...item,
            cOrderLink: `${baseLink}${item.accountId}`
          }
        })
      }).finally(() => {
        this.isLoading = false
      })
    },
    goSearch () {
      this.pageInfo.current = 1
      this.getList()
    },
    // 新增、修改回调
    successHandler () {
      this.showCreateDrawer = false
      this.getList()
    }
  }
}
</script>
<style scoped>
.link {
  padding-left: 24px;
  font-size: 14px;
}
.shadow-box {
  padding: 12px 24px 16px 24px;
}

.batch-edit {
  display: flex;
  align-items: center;
}
.batch-edit .input {
  width: 120px;
  margin: 0 6px;
}
.header-actions .el-button + .el-button {
  margin-left: 12px;
}
.commission-rate-info {
  margin-right: 16px;
  font-size: 14px;
  color: #333;
}
.edit-icon {
  margin-left: 4px;
  color: #0076F6;
  cursor: pointer;
  font-size: 14px;
}
.commission-rate-tip {
  margin-bottom: 16px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 20px;
  color: #666;
  background-color: #f5f7fa;
  border-radius: 4px;
}
</style>